import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import { LoadingSpinner } from '../../../../components/layouts';
import { ProfileActionsType } from '../../../../types/menu.d';
import { AppConfig, ContactFormType, Customer } from '../../../../weborder/Api';
import * as Data from '../../../../weborder/Data';
import { cookieSelectors } from '../../../../weborder/selectors';
import * as Store from '../../../../weborder/Store';
import {
  CustomerProfilePartial,
  GuestProfilePartial,
  NotLoggedInPartial,
} from './components';

type ParamProps = {
  id: number;
  type: 'collection' | 'delivery';
  vrid: number;
};
type StateProps = ReturnType<typeof mapStateToProps>;
type OuterProps = {
  actions: ProfileActionsType;
  configData: AppConfig;
  contactFormType: ContactFormType;
  customer: Data.Async<Customer>;
  hasDisableNonEssentialCookies: boolean;
  hasGdprCookieFeatureFlag: boolean;
  languageCode: string;
  params: ParamProps;
  translate: any;
};
type Props = OuterProps & StateProps;

const useStyles = makeStyles((theme: Theme) => ({
  profilePanel: {
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(2, 0, 3.5),
  },

  loadingState: {
    display: 'flex',
    padding: theme.spacing(3, 0),
  },

  [theme.breakpoints.up('sm')]: {
    profilePanel: {
      margin: theme.spacing(2, 3, 10),
    },
  },

  [theme.breakpoints.up('md')]: {
    profilePanel: {
      margin: theme.spacing(2, 0, 10),
    },
  },

  [theme.breakpoints.up('lg')]: {
    profilePanel: {
      border: `1px solid ${theme.palette.grey[400]}`,
      margin: theme.spacing(2, 0),
      padding: theme.spacing(0, 3),
    },
  },
}));

function ProfilePanel(props: Props): JSX.Element {
  const classes = useStyles();
  const {
    actions,
    configData,
    contactFormType,
    customer,
    hasDisableNonEssentialCookies,
    hasGdprCookieFeatureFlag,
    languageCode,
    params,
    translate,
  } = props;

  const renderProfilePanelState = (): JSX.Element => {
    if (!customer || !customer?.status || customer.status === 'pending') {
      return (
        <LoadingSpinner className={classes.loadingState} variant="inline" />
      );
    }

    if (customer.status === 'success') {
      if (customer.data.IsGuest) {
        return (
          <GuestProfilePartial
            actions={actions}
            contactFormType={contactFormType}
            translate={translate}
          />
        );
      }

      return (
        <CustomerProfilePartial
          actions={actions}
          configData={configData}
          contactFormType={contactFormType}
          customerData={customer.data}
          hasDisableNonEssentialCookies={hasDisableNonEssentialCookies}
          hasGdprCookieFeatureFlag={hasGdprCookieFeatureFlag}
          languageCode={languageCode}
          params={params}
          translate={translate}
        />
      );
    }

    return (
      <NotLoggedInPartial
        actions={actions}
        configData={configData}
        contactFormType={contactFormType}
        translate={translate}
      />
    );
  };

  return (
    <div className={classes.profilePanel}>{renderProfilePanelState()}</div>
  );
}

const mapStateToProps = (state: Store.State) => ({
  hasDisableNonEssentialCookies: cookieSelectors.hasDisableNonEssentialCookies(
    state,
  ),
  hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
});

export default connect(mapStateToProps)(ProfilePanel);
